import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ProductForm = ({ product, onProductAdded, onProductUpdated, onAlert }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [color,setColor] = useState('')
  const [images, setImages] = useState([]);
  const [category, setCategory] = useState('');
  const [imageUrls, setImageUrls] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);

  const STATIC_DETAILS = "Material: High-quality Aluminium | Finish: Powder Coated | Warranty: 1 Year | Country of Origin: India";

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://royaleva.hxbindia.com/categories');
        setCategories(response.data);
        setLoadingCategories(false);
      } catch (error) {
        console.error('Error fetching categories:', error);
        onAlert('Error fetching categories.', 'danger');
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (product) {
      setName(product.name);
      setDescription(product.description);
      setCategory(product.category._id);
      setColor(product.color)
      setImageUrls(product.image);
    }
  }, [product]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('color',color)
    formData.append('details', STATIC_DETAILS); // Static details
    formData.append('category', category);

    images.forEach((image) => formData.append('image', image));

    try {
      if (product) {
        await axios.put(`https://royaleva.hxbindia.com/products/${product._id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        onProductUpdated();
        onAlert('Product updated successfully!', 'success');
      } else {
        const response = await axios.post('https://royaleva.hxbindia.com/products', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        onProductAdded(response.data);
        onAlert('Product created successfully!', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      onAlert('Error performing action.', 'danger');
    }
  };

  return (
    <div className="container d-flex justify-content-center">
      <div className="col-md-7 pt-5">
        <h1 className="text-secondary mb-5">Manage Products</h1>
        <ul>
          <h4>Steps To Follow</h4>
          <hr />
          <li>Use "|" to separate or break line in description.</li>
          <li>Maximum 5 images can be uploaded.</li>
          <li>Use Dropdown to select the Category.</li>
        </ul>
        {loadingCategories ? (
          <p>Loading categories...</p>
        ) : (
          <form onSubmit={handleSubmit} className="mb-3">
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder='use "|" to break line'
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Color</label>
              <input
                type="text"
                className="form-control"
                value={color}
                onChange={(e) => setColor(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Category</label>
              <select
                className="form-control"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Images</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => setImages(Array.from(e.target.files))}
                multiple
              />
            </div>
            {imageUrls.length > 0 && (
              <div className="mb-3 d-flex flex-wrap gap-2">
                {imageUrls.map((url, index) => (
                  <img
                    key={index}
                    src={`https://royaleva.hxbindia.com${url}`}
                    alt={`Product ${index}`}
                    className="img-fluid"
                    style={{ maxWidth: '100px', height: '100px' }}
                  />
                ))}
              </div>
            )}
            <button type="submit" className="btn btn-secondary">
              {product ? 'Update' : 'Add'} Product
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ProductForm;
